import { RestHost } from 'common-functions';
import { getConfiguratinSettings } from '../../shared/services/configApi';
import { setConfigValue } from '../slices/configSlice';

export const configRequest = async ({ dispatch }) => {
    const response = await getConfiguratinSettings();
    console.log('config response...............................', response);
    dispatch(setConfigValue(response?.data));
};
